<template>
  <div id="ModifyStore">
    <div class="contentRight2" style="height:100%;width:calc(100vw - 200px)">
      <div class="rightHead" style="border-bottom:1px solid #eee">
        <div style=";margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">店铺设置</div>
      </div>
      <div class="content">
        <div style="box-sizing: border-box;">
          <!-- 表单验证 -->
          <div class="from">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              :rules="rules"
              class="demo-ruleForm"
              label-width="150px"
              label-position="right"
              hide-required-asterisk
            >
              <el-form-item label="店铺名称：" v-if="!isShow">
                <span>{{shopInformation.shopName}}</span>
                <span
                  style="color:rgb(16, 142, 233);margin-left:10px;cursor:pointer;"
                  @click="isShow = !isShow"
                >修改</span>
              </el-form-item>
              <el-form-item label="店铺名称：" v-if="isShow">
                <el-input
                  size="small"
                  style="width:280px"
                  placeholder="输入商品名称"
                  v-model="ruleForm.shopName"
                ></el-input>
              </el-form-item>
              <el-form-item label="主营类目：">{{shopInformation.shopCategoryName}}</el-form-item>
              <el-form-item label="创建日期：">{{shopInformation.modifyTime}}</el-form-item>
              <el-form-item label="店铺logo：">
                <el-upload
                  class="avatar-uploader"
                  action="https://api.yichengshi.cn/ImageServer/YmUpload_image"
                  :show-file-list="false"
                  list-type="picture-card"
                  :http-request="loadImg7"
                >
                  <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <!-- <div class="text2" style="width:230px;">图片大小不得超过3M，建议使用方形图片</div> -->
              </el-form-item>
              <el-form-item label="店铺简介：" prop>
                <el-input
                  style="width:280px;height:60px"
                  size="small"
                  placeholder="输入店铺简介"
                  type="textarea"
                  v-model="ruleForm.shopDescription"
                ></el-input>
              </el-form-item>
              <el-form-item label="店长手机：" prop>
                <el-input
                  size="small"
                  style="width:280px"
                  placeholder="输入手机号"
                  v-model="ruleForm.shopTel"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否关注发券" prop>
                <el-switch v-model="isFocusCashCoupon" @change="isFocusCashCouponChange" />
              </el-form-item>
              <el-form-item label="选择优惠券" v-show="isFocusCashCoupon == true">
                <el-select v-model="cashCouponBatchOrderId" placeholder="请选择">
                  <el-option
                    v-for="item in cardCouponList"
                    :key="item.cashCouponBatchOrderId"
                    :label="item.title"
                    :value="item.cashCouponBatchOrderId">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button size="small" type="primary" @click="submitForm('ruleForm')">确定修改</el-button>
                <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadImg, getCashCouponBatchList } from "../api";
export default {
  data() {
    return {
      isShow: false,
      //商品分类
      tableData: [],
      imageUrl: require("../../assets/icon/mdzp1.png"),
      ruleForm: {
        imageUrl: require("../../assets/icon/mdzp1.png"),
        shopLogo: "",
        shopName: "",
        shopDescription: "",
        shopTel: "",
        shopAddress: ""
      },
      //表单验证规则
      rules: {
        goodsName: [
          { required: true, message: "请输入商品名称", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "change" }
        ]
      },
      userList: "", //用户信息
      shopInformation: "", //店铺信息
      isFocusCashCoupon: false,
      cardCouponList: [],
      cashCouponBatchOrderId: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.ruleForm.shopAddress = shopInformation.shopAddress;
    this.ruleForm.shopLogo = shopInformation.shopLogo;
    this.ruleForm.imageUrl = shopInformation.shopLogo;
    this.ruleForm.shopName = shopInformation.shopName;
    this.ruleForm.shopTel = shopInformation.shopTel;
    this.ruleForm.shopDescription = shopInformation.shopDescription;
    this.shopInformation = shopInformation;
    this.isFocusCashCoupon = shopInformation.isFocusCashCoupon == 1 ? true : false
    this.cashCouponBatchOrderId = shopInformation.focusCashCouponId
    if (this.isFocusCashCoupon == true) {
      this.getCashCouponBatchList()
    }
  },
  methods: {
    isFocusCashCouponChange(val) {
      if (val == true) {
        this.getCashCouponBatchList()
      }
    },
    Shop_shopInfo() {
      this.request
        .get("qrcapi/Shop_shopInfo", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id
        })
        .then(res => {
          console.log(res, "店铺信息");
          this.setCookie("shopInformation", JSON.stringify(res.data));
          this.$store.state.shopInformation = res.data
          this.shopInformation = shopInformation;
          this.isShow = false;
          this.shopList = res.data;

          if (res.code == 1) {
          } else {
            this.$message.error("未创建店铺");
            this.$router.push("/creatStore");
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    getCashCouponBatchList() {
      getCashCouponBatchList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNo : 1,
        row: 999,
        orderStatus: 2
      })
      .then(res => {
        if (res.code == 1) {
          // this.cardCouponList = res.data
          var timestamp = Date.parse(new Date());
          var newList = res.data.filter(item => {
            var time3 = Date.parse(item.expireDay);
            return timestamp - time3 <= 86400
          })
          console.log(newList, "新数组")
          this.cardCouponList = newList
        } else if (res.code == -1) {
          this.$message.error(res.msg);
        } else if (res.code == 2) {
          this.$router.push("/");
          this.$message.error(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    //修改店铺信息
    submitForm(formName) {
      console.log(this.isFocusCashCoupon)
      var ruleForm = this.ruleForm;
      this.request
        .post("qrcapi/Shop_modifyShopInfo", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopName: ruleForm.shopName, //店铺名称
          // shopCategoryId: shopCategoryId, //分类
          shopDescription: ruleForm.shopDescription,
          shopLogo: ruleForm.shopLogo,
          shopTel: ruleForm.shopTel,
          // shopAddress:ruleForm.shopAddress,
          coodinateSystemType: 2,   // 1.gps  2.百度坐标  3.图吧  4.高德（火星坐标）
          isFocusCashCoupon: this.isFocusCashCoupon == true ? 1 : 0,
          focusCashCouponId: this.isFocusCashCoupon == true ? this.cashCouponBatchOrderId : null
        })
        .then(res => {
          if (res.code == 1) {
            console.log(res, "店铺修改");
            this.$message({
              message: "success",
              type: "success"
            });

            this.Shop_shopInfo();
          } else if (res.code == 2) {
            this.$router.push("/");
            that.$message.error(res.msg);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    loadImg7(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);

      uploadImg(imgUploadForm)
        .then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.ruleForm.shopLogo = res.data.data.url;
            this.ruleForm.imageUrl = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {});
    },
    handleAvatarSuccess1(res, file) {
      //上传成功时
      //   this.imageUrl1 = URL.createObjectURL(file.raw);
      console.log(res, file);
    },
    beforeAvatarUpload(file) {
      console.log(file, "beforeAvatarUpload");
      // return false  //屏蔽了action的默认上传
      // 上传之前
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    }
  }
};
</script>

<style scoped>
.text2 {
  font-size: 12px;
  color: #bbb;
  margin-top: 10px;
}
.content {
  padding: 20px 0px;
  /* padding-top: 70px; */
  border-top: 1px solid #eee;
}
.from {
  box-sizing: border-box;
  width: 100%;
  padding: 35px 0 0 0px;
  overflow-x: scroll;
  height: calc(100vh - 50px);
}
.from::-webkit-scrollbar{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/ModifyStore.vue